import {IOpenOrderSettings} from './ao-open-order-settings.interface';
import {_DEFAULT_AUTO_ORDER_OPEN_ORDER_FILTER_SETTINGS} from './ao-open-order-filter-settings.default';
import {_DEFAULT_OPEN_ORDER_VIEW_SETTINGS} from './ao-open-order-view-settings.default';

//#region DEFAULT _DEFAULT_OPEN_ORDER_SETTINGS
export const _DEFAULT_OPEN_ORDER_SETTINGS: Readonly<IOpenOrderSettings> = {
  filters: _DEFAULT_AUTO_ORDER_OPEN_ORDER_FILTER_SETTINGS,
  orderSettings: _DEFAULT_OPEN_ORDER_VIEW_SETTINGS
} as const;
//#endregion